import {
  Button,
  FlexBox,
  ModalBody,
  ModalFoot,
  ModalHead,
  Text,
} from '@dixa/lib-shared-habla';
import { useArticleDetachFromElevioMutation } from 'lib-knowledge-management-common/graphql';
import { ModalWrapper, useModal } from 'lib-knowledge-modal';
import { useNotification } from 'lib-knowledge-utils/hooks/useNotification';

type ArticleDetachModalProps = {
  articleId: string;
};
export function ArticleDetachModal({
  articleId,
}: ArticleDetachModalProps): JSX.Element {
  const { hideModal } = useModal();
  const [detachFn, { loading }] = useArticleDetachFromElevioMutation();
  const { successNotify, errorNotify } = useNotification();

  async function onDetach() {
    try {
      await detachFn({ variables: { id: articleId } });
      hideModal();
      successNotify({
        title: 'Success',
        text: 'The article has been detached from its Elevio source.',
      });
    } catch (_error) {
      errorNotify({
        text: 'Something went wrong. Please try again.',
      });
    }
  }

  return (
    <ModalWrapper>
      <ModalHead title="Detach article" onClose={hideModal}></ModalHead>
      <ModalBody>
        <Text.Paragraph withMarginBottom>
          Are you sure you want to detach this article? It will no longer
          receive updates when syncing content with Elevio. This can not be
          undone.
        </Text.Paragraph>
      </ModalBody>
      <ModalFoot>
        <FlexBox justifyContent="flex-end" gap="100">
          <Button disabled={loading} variant="tertiary" onClick={hideModal}>
            Cancel
          </Button>
          <Button variant="danger" disabled={loading} onClick={onDetach}>
            {loading ? 'Detaching...' : 'Detach'}
          </Button>
        </FlexBox>
      </ModalFoot>
    </ModalWrapper>
  );
}
